import { useState, useMemo } from "react";
import { Package, ChevronDown, ChevronUp, MapPin } from "lucide-react";
import RemesaGroupByRoute from "./RemesaGroupByRoute";
import "../../../css/OnRoad.css";

export default function RemesaGroupsContainer({ gruposRuta, informacionEstado }) {
    const [isExpanded, setIsExpanded] = useState(false);

    // Calcular estadísticas totales de todos los grupos
    const estadisticasTotales = useMemo(() => {
        if (!gruposRuta || gruposRuta.length === 0) {
            return {
                totalRutas: 0,
                totalRemesas: 0,
                rutasTexto: ''
            };
        }

        const totalRemesas = gruposRuta.reduce((acc, grupo) => acc + grupo.remesas.length, 0);
        
        // Generar texto descriptivo de rutas (máximo 2 rutas mostradas)
        const rutasTexto = gruposRuta.length <= 2
            ? gruposRuta.map(g => `${g.origen} → ${g.destino}`).join(', ')
            : `${gruposRuta[0].origen} → ${gruposRuta[0].destino} y ${gruposRuta.length - 1} más`;

        return {
            totalRutas: gruposRuta.length,
            totalRemesas,
            rutasTexto
        };
    }, [gruposRuta]);

    // Handler para toggle de expansión
    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    // Si no hay grupos, no renderizar nada
    if (!gruposRuta || gruposRuta.length === 0) {
        return null;
    }

    return (
        <div className="remesa-groups-container">
            {/* Header clickeable del contenedor principal */}
            <div 
                className={`remesa-groups-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
                role="button"
                aria-expanded={isExpanded}
                aria-label={`${isExpanded ? 'Colapsar' : 'Expandir'} grupos de remesas`}
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleExpanded();
                    }
                }}
            >
                {/* Icono principal */}
                <div className="groups-header-icon">
                    <Package size={22} />
                </div>

                {/* Información del contenedor */}
                <div className="groups-header-info">
                    <div className="groups-header-title">
                        <span className="title-main">Grupos de Remesas</span>
                        {estadisticasTotales.totalRutas > 1 && (
                            <span className="title-badge multiple">
                                {estadisticasTotales.totalRutas} rutas
                            </span>
                        )}
                    </div>
                    
                    <div className="groups-header-subtitle">
                        <MapPin size={14} />
                        <span>{estadisticasTotales.rutasTexto}</span>
                    </div>
                </div>

                {/* Icono de expansión */}
                <div className="groups-expand-icon">
                    {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </div>
            </div>

            {/* Contenido desplegable con los grupos individuales */}
            <div className={`remesa-groups-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
                {isExpanded && (
                    <div className="remesa-groups-list">
                        {gruposRuta.map((grupoRuta, index) => (
                            <RemesaGroupByRoute
                                key={`${grupoRuta.origen_dane}_${grupoRuta.destino_dane}_${index}`}
                                grupoRuta={grupoRuta}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}